export default __webpack_public_path__ + "static/media/icons-slip-48-px.fd1489a0.svg";